import React, {createContext, useContext, useState, useEffect} from 'react';
import {getAuth, onAuthStateChanged} from 'firebase/auth';
import {doc, onSnapshot} from "firebase/firestore";
import {getFirestore} from "firebase/firestore";

const UserContext = createContext();

export const useUser = () => {

  return useContext(UserContext);
};

export const UserProvider = ({children}) => {
  const [user, setUser] = useState(null);
  const [appUser, setAppUser] = useState(null);

  // set auth user observer on load
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, user => {
      setUser(user);
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let unsubscribe;
    if (user) {
      const db = getFirestore();
      const docRef = doc(db, "users", user.email);
      unsubscribe = onSnapshot(docRef, (snapshot) => {
        setAppUser({id: snapshot.id, ...snapshot.data()});
      });
    } else {
      setAppUser(null);
    }
    if (unsubscribe) {
      return unsubscribe;
    }
  }, [user]);

  // context returns
  // user: firebase user
  // appUser: user object representing {account, role} with id of email
  const value = {
    user,
    appUser,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
